import { ReactNode } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { OverlayTriggerProps } from 'rsuite/esm/internals/Overlay/OverlayTrigger';

interface Props {
  children: ReactNode;
  /** Text content for tooltip */
  text: string;
  /** Identifier for tooltip to link to triggering element */
  tooltipIdentifier: string;
  tooltipPosition: OverlayTriggerProps['placement'];
}

export function RsuiteTooltipWrapper(props: Props) {
  const { children, text, tooltipIdentifier, tooltipPosition } = props;

  return (
    <Whisper
      placement={tooltipPosition}
      speaker={<Tooltip id={tooltipIdentifier}>{text}</Tooltip>}
      trigger="hover"
    >
      {children}
    </Whisper>
  );
}
